import { render, staticRenderFns } from "./account-preferences.vue?vue&type=template&id=a10ce226"
import script from "./account-preferences.vue?vue&type=script&lang=js"
export * from "./account-preferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports